/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.content-center {
  @apply justify-center text-center;
}

.content-left {
  @apply justify-start;
}

.content-right {
  @apply justify-end;
}

.large-image-main-title {
  @apply w-fit h-auto text-left font-poppins fs-4 self-start px-24px mb-32px;
}

.large-image-switcher-wrapper {
  @apply w-full h-auto flex flex-col-reverse sm:flex-row-reverse justify-center items-stretch gap-x-[16px] md:gap-x-[40px] relative;
}

.large-image-switcher-wrapper .large-image-main-title {
  @apply w-fit h-auto text-left font-poppins fs-4 self-start px-24px mb-32px;
}

.large-image-switcher-wrapper .large-image-switcher-tabs {
  @apply w-full h-auto flex flex-col justify-center sm:justify-end items-end max-sm:mt-8px gap-y-[8px] max-sm:gap-x-[8px] relative z-20 max-sm:grid max-sm:grid-cols-2 max-sm:grid-rows-2;
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab {
  @apply w-full h-full max-sm:min-h-[150px] sm:h-auto sm:pr-12px flex flex-col sm:flex-row justify-center sm:justify-start items-center sm:gap-x-[69px] rounded-[12px] border-[1px] border-ui-gray-4 font-poppins fs-0 font-medium cursor-pointer p-12px sm:py-20px sm:px-24px;
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab.active {
  @apply bg-medium-blue border-medium-blue !text-white ;
}

@media(min-width: 768px) {
  .large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab.active {
    width: calc(100% + 80px);
  }
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab-arrow {
  @apply w-fit h-auto hidden max-sm:mb-12px max-sm:rotate-90;
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab.active .large-image-switcher-tab-arrow {
  @apply flex justify-start items-center;
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab.active .large-image-switcher-tab-arrow::before {
  content: '';
  @apply w-[10px] h-24px bg-white;
  mask-image: url('/wp-content/themes/3ecotheme/component-library/src/assets/general-icons/tab-switcher-arrow.svg');
  mask-size: cover;
  mask-position: center;
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab-icon-title {
  @apply font-poppins fs-0 font-medium block;
}

.large-image-switcher-wrapper .large-image-switcher-tabs .large-image-switcher-tab.active .large-image-switcher-tab-icon-wrapper{
  @apply bg-medium-blue text-white;
}


.large-image-switcher-wrapper .large-image-switcher-slide {
  @apply w-full h-auto max-w-[700px] block rounded-[12px] overflow-hidden relative z-10;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-content .large-image-switcher-slide-content-icon-title-mobile {
  @apply block sm:hidden font-poppins fs-1 font-medium text-medium-blue;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper {
  @apply w-full h-full aspect-square;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper .large-image-switcher-slide-asset {
  @apply w-full h-auto object-cover rounded-[12px] aspect-square;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper .large-image-switcher-slide-video {
  @apply w-full h-auto rounded-[12px] hidden;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper .large-image-switcher-slide-video .plyr {
  @apply !rounded-[12px];
  background: transparent !important;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper .large-image-switcher-slide-video .plyr__video-wrapper {
  @apply !rounded-[12px];
  background: transparent !important;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper .large-image-switcher-slide-video .plyr__controls {
  @apply !hidden;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper.video-active .large-image-switcher-slide-asset {
  @apply hidden;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper.video-active .large-image-switcher-slide-video {
  @apply block;
}

.large-image-switcher-wrapper .large-image-switcher-slide .large-image-switcher-slide-asset-wrapper.video-active {
  @apply aspect-auto;
}

@media(max-width: 767px) {
  .large-image-switcher-container {
    @apply !pr-0;
  }

} 

@media(min-width: 1000px) and (max-width: 1199px) {
  .large-image-switcher-wrapper{
    @apply gap-x-[24px];
  }

  .large-image-switcher-wrapper .large-image-switcher-tabs{
    @apply max-w-[40%];
  }

  .large-image-switcher-wrapper .large-image-main-title {
    @apply mb-0;
  }
}

/* Tab Animations */

.large-image-switcher-slide-asset-wrapper{
  opacity: 1;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
}


.large-image-switcher-slide-asset-wrapper.animate-in {
  animation-name: slide-fade-in;
}

.large-image-switcher-slide-asset-wrapper.animate-out {
  animation-name: slide-fade-out;
}

@keyframes slide-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes slide-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


/* Animation */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1 {
  @apply bg-white absolute w-full h-full top-0 left-0 z-30 opacity-50;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.large-image-switcher-wrapper.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: .15s;
  }
  

